import { useState } from 'react';

import Header from '../common/Header';
import PhoneInput from '../common/PhoneInput';
import LoadingSpinner from '../common/LoadingSpinner';

import { useAuthContext } from '../Auth/context';
import styles from '../assets/css/auth.module.css';
import useAPI from './useApi';
import usePageTracking from '../lib/usePageTracking';

const Account = () => {
  const { state: { user } } = useAuthContext();

  const [showForm, setShowForm] = useState(false);

  const switchToEdit = () => setShowForm(true);
  const cancelEdit = () => setShowForm(false);

  const { data: { countries }, actions: { updateAccount }, errors = {}, status } = useAPI({
    callback: cancelEdit
  });
  usePageTracking();

  return (
    <>
      <Header />
      <div className={styles.main_wrapper}>
        <div className={styles.profile_header}>
          <p>{user.fullName}</p>
          <p>{user.email}</p>
        </div>
        {!showForm
          ? <Profile
            user={user}
            switchToEdit={switchToEdit}
            errors={errors}
          />
          : <AccountForm
            user={user}
            cancelEdit={cancelEdit}
            countries={countries}
            updateAccount={updateAccount}
            errors={errors}
            status={status}
          />
        }
      </div>
    </>
  );
};

const Profile = ({ user, switchToEdit, errors }) => (
  <div className={styles.container}>
    <div className={styles.edit} onClick={switchToEdit}>
      <p>تعديل</p>
      <i className="fas fa-fw fa-edit"></i>
    </div>
    <div className={styles.container_row}>
      <div className={styles.container_row_input}>
        <p>رقم الموبايل</p>
        <p>{user.mobile || 'غير متوفر'}</p>
      </div>
      <div className={styles.container_row_input}>
        <p>رقم واتساب</p>
        <p>{user.whatsapp || 'غير متوفر'}</p>
      </div>
    </div>
    <div className={styles.container_row}>
      <div className={styles.container_row_input}>
        <p>حالة الحساب</p>
        <p>{user.active ? 'نشط' : 'غير نشط'}</p>
      </div>
    </div>
  </div>
);

const AccountForm = ({ user, cancelEdit, updateAccount, countries, errors, status }) => {
  const [payload, setPayload] = useState({
    mobile: user.mobile || '',
    whatsapp: user.whatsapp || ''
  });
  const handleChange = (name, value) => setPayload({ ...payload, [name]: value });
  const submit = (e) => {
    e.preventDefault();
    updateAccount(payload);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.container_row}>
          <div className={styles.container_row_input}>
            <p>رقم الموبايل</p>

            <PhoneInput
              list={countries}
              onChange={(value) => handleChange('mobile', value)}
              value={payload.mobile}
              placeholder="رقم الهاتف بدون صفر البداية"
              error={errors.mobile}
              name="mobile"
              style={{ top: 'auto' }}
            />
          </div>

          <div className={styles.container_row_input}>
            <p>رقم واتساب</p>
            <PhoneInput
              list={countries}
              onChange={(value) => handleChange('whatsapp', value)}
              value={payload.whatsapp}
              placeholder="رقم الواتساب بدون صفر البداية"
              error={errors.whatsapp}
              name="whatsapp"
              style={{ top: 'auto' }}
            />
          </div>
        </div>

        <div className={styles.container_row}>
          <div className={styles.container_row_input}>
            <p>حالة الحساب</p>
            <p>{user.active ? 'نشط' : 'غير نشط'}</p>
          </div>
        </div>
      </div>

      <div className={styles.form_buttons}>
        <button className="button" onClick={submit} disabled={status === 'submitting'}>
          حفظ التغيرات
          {status === 'submitting' && <LoadingSpinner />}
        </button>
        <button className='button' onClick={cancelEdit}>الغاء</button>
      </div>
    </>
  );
};

export default Account;
